<template>
  <div class="feedback">
   
    <div class="box_panel">
      <img
        class="feedbackList_img"
        src="../../assets/images/mine/yijianfankui_bg.png"
        alt=""
      />
      <div class="top_tip">
        <div class="p1">Hi ~ 有什么可以帮您？</div>
        <div class="p2">请输入您要咨询反馈的内容</div>
      </div>
      <div class="question_box" id="dialogue_box">
        <div class="question_list question_list_service">
          <div class="left">
            <img class="head" src="@/assets/images/mine/kefu.png" alt="" />
          </div>
          <div class="right">
            <div class="content">
              <template v-if="feedType == 1"
                >您好，您想咨询【{{
                  activityData.name
                }}】此活动的什么问题？</template
              >
              <template v-if="feedType == 2"
                >您好，您想咨询平台相关的什么问题？</template
              >
              <template v-if="feedType == 3"
                >您好，您可以在下方输入您的建议哦。</template
              >
            </div>
            <!-- <div class="time">
							2024/01/01 17:35
						</div> -->
          </div>
        </div>
        <template v-for="(item, index) in feedbackList">
          <div
            class="question_list question_list_mine"
            v-if="item.isFeedbackUser"
          >
            <div class="left" style="display: none">
              <img class="head" src="@/assets/images/mine/kefu.png" alt="" />
            </div>
            <div class="right">
              <div class="content">{{ item.content }}</div>
              <div class="time">{{ item.addTime }}</div>
            </div>
          </div>
          <div class="question_list question_list_service" v-else>
            <div class="left">
              <img class="head" src="@/assets/images/mine/kefu.png" alt="" />
              <div style="text-align: center;">{{item.userType==5?'省端':'平台'}}</div>
            </div>
            <div class="right">
              <div class="content">
				{{ item.content }}
              </div>
              <div class="time">{{ item.addTime }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="bottom_panel">
      <div class="left">
        <van-field
          v-model="suggest"
          type="text"
          maxlength="300"
          placeholder="请输入您的问题吧 ~"
        />
      </div>
      <div class="btn" @click="save">
        <img class="" src="@/assets/images/mine/botton_fasong.png" alt="" />
      </div>
    </div>
	<m-loading :loading="homeLoading" />
    <!-- <van-field v-model="suggest" rows="4" :autosize="{ 'maxHeight': 300,'minHeight':400}" type="textarea"
			maxlength="300" placeholder="请输入建议内容" show-word-limit />
		<div class="save">
			<van-button size="large" :loading="subLoading" color="linear-gradient(to right, #5DD682, #5AFF8E)"
				@click="save">提交</van-button>
		</div> -->
  </div>
</template>

<script>
import {
  submitFeedback,
  submitFeedbackReply,
  detailFeedback
} from "@/utils/api/user";
export default {
  data() {
    return {
      suggest: "",
      subLoading: false,
      feedType: this.$route.query.type,
      activityData: this.$route.query.data
        ? JSON.parse(this.$route.query.data)
        : null,
      saveState: this.$route.query.feedbackId ? false : true,
      feedbackId: this.$route.query.feedbackId,
      feedbackList: [],
      homeLoading: true
    };
  },
  async mounted() {
	this.homeLoading = false;
    if (this.feedbackId) {
      this.homeLoading = true;
      this.getDetailFeedback();
    }
  },
  methods: {
    getDetailFeedback() {
      detailFeedback(this.feedbackId).then((res) => {
        if (res.success) {
          this.feedbackList = res.data;
          this.$nextTick(() => {
            var div = document.getElementById("dialogue_box");
            div.scrollTop = div.scrollHeight;
          });
          this.homeLoading = false;

          console.log(res.data);
        }
      });
    },
    save() {
      this.subLoading = true;
      if (!this.suggest) {
        this.$toast.fail("反馈内容不可为空");
      }
      const dataItem = {
        content: this.suggest,
        feedbackType: this.feedType,
        activityId: this.activityData ? this.activityData.id : null
      };
      if (this.saveState) {
        submitFeedback(dataItem).then((res) => {
          if (res.success) {
            this.subLoading = false;
            this.saveState = false;
            this.suggest = "";
            this.feedbackId = res.data.id;
			this.getDetailFeedback();

            // this.$root.$toast.success({
            //   message: "提交成功",
            //   duration: 1500,
            //   onClose: () => {
            //     this.$router.go(-1);
            //   }
            // });
          }
        });
      } else {
        submitFeedbackReply({
          ...dataItem,
          feedbackId: this.feedbackId
        }).then((res) => {
          if (res.success) {
            this.suggest = "";
            this.getDetailFeedback();
          }
        });
      }
      //首次提问
    }
  },
  updated() {
    this.$nextTick(() => {
      var div = document.getElementById("dialogue_box");
      div.scrollTop = div.scrollHeight;
    });
  }
};
</script>

<style lang="scss" scoped>
.feedback {
  width: 375px;
  position: absolute;
  height: 100vh;
  background-color: #f9f9fa;

  display: flex;
  flex-direction: column;
  overflow-x: hidden;

  .bottom_panel {
    position: relative;
    // height: 80px;
    background-color: #fff;
    padding: 15px 15px;
    display: flex;
    align-items: center;

    .left {
      flex: 1;
    }

    .btn {
      margin-left: 10px;

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .feedbackList_img {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0;
    // height: 339px;
    width: 10rem;
    margin: 0 auto;
  }

  .box_panel {
    position: relative;
    text-align: left;
    flex: 1;
    overflow-y: auto;
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    .top_tip {
      padding: 15px;
      position: relative;
      z-index: 2;

      .p1 {
        font-weight: bold;
        font-size: 18px;
        color: #222222;
      }

      .p2 {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        padding-top: 8px;
      }
    }

    .question_box {
      padding-top: 20px;
      position: relative;
      z-index: 2;
      flex: 1;
      overflow-y: auto;

      .question_list {
        display: flex;
        padding-bottom: 25px;

        .head {
          width: 35px;
          height: 35px;
        }

        .time {
          padding-top: 10px;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          padding-left: 10px;
        }

        .content {
          font-size: 14px;

          line-height: 20px;
          text-align: left;
          border-radius: 1px 25px 25px 25px;
          padding: 10px 15px 10px 20px;
          // margin-left: 10px;
        }
      }

      .question_list_service {
        padding-right: 40px;

        .content {
          background-color: #fff;
          font-weight: 400;
          color: #333333;
          margin-left: 10px;
        }
      }

      .question_list_mine {
        justify-content: flex-end;
        padding-left: 40px;
        .right {
          display: flex;
          flex-flow: column;
          align-items: flex-end;
        }
        .content {
          background: #31d076;
          font-weight: 400;
          color: #fff;
          margin-left: 10px;
          border-radius: 25px 1px 25px 25px;
          min-width: 50px;
        }

        .time {
          text-align: right;
          padding-right: 10px;
        }
      }
    }
  }

  .van-cell {
    // border: 1px solid #e4e4e4;
    border-radius: 5px;
    background: #f8f8f9;
    border-radius: 100px 100px 100px 100px;
    // height: 40px;
    // line-height: 32px;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    padding: 9px 18px;
  }

  .save {
    width: 290px;
    margin: 0 auto;
    margin-top: 30px;

    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>
